import React from "react";
import Footer from "../components/shared/Footer";
import Cookies from "js-cookie";

function EmptyLayout(props) {
  const language = Cookies.get("locale");
  const save = language==="fr"?'fr':"ar-tn"
  require('moment/locale/'+save )
  return (
    <>
  
      <React.Fragment>{props.children}</React.Fragment>
      <Footer/>
    </>
  );
}

export default EmptyLayout;
